import { brand } from '@/brand/brand'
import { cn } from '@/lib/utils'

/**
 * The brand logo mark — a single per-brand image driven by brand.logoUrl.
 * Every logo surface renders THIS, so the mark is pure brand data: each brand
 * shows its own logo, read from the brand pack. No brand artwork is hardcoded.
 */
const SIZES = {
    sm: 'size-7',
    md: 'size-9',
    lg: 'size-11',
} as const

export function BrandMark({
    size = 'sm',
    className,
}: {
    size?: keyof typeof SIZES
    className?: string
}) {
    return (
        <img
            src={brand.logoUrl}
            alt={`${brand.company} logo`}
            className={cn(SIZES[size], 'shrink-0 rounded-md object-contain', className)}
            draggable={false}
        />
    )
}
